module.exports = __webpack_public_path__ + "media/images/pen_blue-2117fbfe.png";